import { useEffect } from 'react';
import Recipient from './components/Recipient';

const SendEmail = ({ setData, data, setError, sms = false, readOnly = false }) => {
  const CARRIER_MAP = [
    { name: 'AT&T', sms: '@txt.att.net', mms: '@mms.att.net' },
    { name: 'T-Mobile', sms: '@tmomail.net', mms: '@tmomail.net' },
    {
      name: 'Verizon Wireless',
      sms: '@vtext.com',
      mms: '@vzwpix.com',
    },
    { name: 'Virgin Mobile', sms: '@vmobl.com', mms: '@vmobl.com' },
    {
      name: 'Sprint',
      sms: '@messaging.sprintpcs.com',
      mms: '@pm.sprint.com',
    },
    {
      name: 'AT&T Enterprise Paging',
      sms: '@page.att.net',
      mms: '@page.att.net',
    },
    {
      name: 'Rogers Wireless',
      sms: '@sms.rogers.com',
      mms: '@pcs.rogers.com',
    },
    {
      name: 'Boost Mobile',
      sms: '@sms.myboostmobile.com',
      mms: '@myboostmobile.com',
    },
    {
      name: 'Telus Mobility',
      sms: '@msg.telus.com',
      mms: '@msg.telus.com',
    },
    {
      name: 'Airfire Mobile',
      sms: '@sms.airfiremobile.com',
      mms: '@sms.airfire.ca',
    },
    {
      name: 'Ameritech',
      sms: '@paging.acswireless.com',
      mms: '@paging.acswireless.com',
    },
    {
      name: 'Assurance Wireless',
      sms: '@vmobl.com',
      mms: '@vmobl.com',
    },
    {
      name: 'BellSouth',
      sms: '@bellsouth.cl',
      mms: '@bellsouth.cl',
    },
    {
      name: 'Bluegrass Cellular',
      sms: '@sms.bluecell.com',
      mms: '@sms.bluecell.com',
    },
    {
      name: 'Cellcom',
      sms: '@cellcom.quiktxt.com',
      mms: '@cellcom.quiktxt.com',
    },
    {
      name: 'Cellular South',
      sms: '@csouth1.com',
      mms: '@csouth1.com',
    },
    {
      name: 'Chariton Valley Wireless',
      sms: '@sms.cvalley.net',
      mms: '@sms.cvalley.net',
    },
    {
      name: 'Chat Mobility',
      sms: '@mail.msgsender.com',
      mms: '@mail.msgsender.com',
    },
    {
      name: 'Cleartalk',
      sms: '@sms.cleartalk.us',
      mms: '@sms.cleartalk.us',
    },
    // {
    //   name: "Consumer Cellular",
    //   sms: "@cingularme.com",
    //   mms: "@mailmymobile.net",
    // },
    {
      name: 'Consumer Cellular',
      sms: '@mailmymobile.net',
      mms: '@txt.att.net',
    },
    {
      name: 'Cricket',
      sms: '@sms.cricketwireless.net',
      mms: '@mms.cricketwireless.net',
    },
    {
      name: 'Element Mobile',
      sms: '@SMS.elementmobile.net',
      mms: '@myelementmobile.com',
    },
    {
      name: 'Esendex',
      sms: '@echoemail.net',
      mms: '@echoemail.net',
    },
    {
      name: 'Mellon Mobile',
      sms: '@mellonmobile.ga',
      mms: '@mellonmobile.com',
    },
    {
      name: 'MetroPCS',
      sms: '@mymetropcs.com',
      mms: '@mymetropcs.com',
    },
    {
      name: 'Nextech',
      sms: '@sms.ntwls.net',
      mms: '@sms.nextechwireless.com',
    },
    {
      name: 'Page Plus Cellular',
      sms: '@vtext.com',
      mms: '@vtext.com',
    },
    {
      name: 'South Central Communications',
      sms: '@rinasms.com',
      mms: '@rinasms.com',
    },
    {
      name: 'Southernlinc',
      sms: '@page.southernlinc.com',
      mms: '@page.southernlinc.com',
    },
    {
      name: 'Straight Talk',
      sms: '@txt.att.net',
      mms: '@mypixmessages.com',
    },
    {
      name: 'Syringa Wireless',
      sms: '@rinasms.com',
      mms: '@vtext.com',
    },
    { name: 'Teleflip', sms: '@teleflip.com', mms: '@rinasms.com' },
    {
      name: 'Union Wireless',
      sms: '@union-tel.com',
      mms: '@teleflip.com',
    },
    {
      name: 'US Cellular',
      sms: '@email.uscc.net',
      mms: '@union-tel.com',
    },
    {
      name: 'Voyager Mobile',
      sms: '@text.voyagermobile.com',
      mms: '@email.uscc.net',
    },
    {
      name: 'Centennial Wireless',
      sms: '@cwemail.com',
      mms: '@text.voyagermobile.com',
    },
    { name: 'TracFone', sms: '@txt.att.net', mms: '@cwemail.com' },
  ];

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    if (phoneNumber.length < 4) return phoneNumber;
    if (phoneNumber.length < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  useEffect(() => {
    if (
      data?.subject === undefined ||
      data?.body === undefined ||
      data?.recipient === undefined ||
      data?.recipients === undefined ||
      data?.recipients?.length === 0
    ) {
      setData({
        subject: '',
        body: '',
        recipient: '',
        recipients: [
          {
            recipient: '',
            carrier: '',
          },
        ],
        // carrier: "",
        error: true,
      });
    }
  }, []);

  const updateData = (item) => {
    setData({
      ...data,
      ...item,
      error: verifyData({ ...data, ...item }),
    });
  };
  const verifyData = (data) => {
    let error = false;
    if (data.subject === '' || data.body === '' || data.recipient === '') {
      error = true;
      setError({ message: 'Action incomplete, check for missing fields.' });
    }

    if (sms) {
      // Check SMS recipients
      for (const recipient of data.recipients) {
        if (!recipient.carrier) {
          error = true;
          setError({ message: 'Please select a carrier for all recipients' });
          break;
        }
        const phone = recipient.recipient.split('@')[0].trim();
        if (!phone.match(/^\d{10}$/)) {
          error = true;
          setError({ message: `Invalid recipient: ${formatPhoneNumber(phone)}` });
          break;
        }
      }
    } else {
      // Check email recipients
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emails = data.recipient.split(',').map((email) => email.trim());

      for (const email of emails) {
        if (!emailRegex.test(email)) {
          error = true;
          setError({ message: `Invalid email address: ${email}` });
          break;
        }
      }
    }

    if (!error) {
      setError(null);
    }
    return error;
  };

  return (
    <div className="global-action-builder-row d-flex flex-column p-3 rounded-2 m-2 gap-3 w-100">
      {/* Recipients */}
      <div className="d-flex flex-column gap-2">
        {data.recipients?.map((recipient, index) => (
          <Recipient
            key={`recipient-${index}-${recipient.recipient}`}
            recipient={recipient}
            index={index}
            updateData={updateData}
            data={data}
            sms={sms}
            CARRIER_MAP={CARRIER_MAP}
            formatPhoneNumber={formatPhoneNumber}
            readOnly={readOnly}
          />
        ))}
      </div>

      {/* Subject */}
      <div className="d-flex flex-column">
        <div className="mb-1">Subject</div>
        <input
          className="global-action-builder-field p-1 rounded-1 w-100"
          type="text"
          name="subject"
          value={data.subject || ''}
          onChange={(e) => updateData({ subject: e.target.value })}
        />
      </div>

      {/* Body */}
      <div className="d-flex flex-column">
        <div className="mb-1">Body</div>
        <textarea
          className="global-action-builder-field p-1 rounded-1 w-100"
          rows={4}
          name="body"
          value={data.body || ''}
          onChange={(e) => updateData({ body: e.target.value })}
        />
      </div>
    </div>
  );
};

export default SendEmail;
